import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { completeGmailConnect } from "@/lib/looseend/gmail.functions";

export const Route = createFileRoute("/oauth/gmail/return")({
  head: () => ({
    meta: [
      { title: "Finishing Gmail connection — L∞seEnd" },
      { name: "description", content: "Completing the development-only Gmail authorization." },
      { property: "og:title", content: "Finishing Gmail connection — L∞seEnd" },
      {
        property: "og:description",
        content: "Completing the development-only Gmail authorization.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: OAuthReturn,
});

const CONNECTOR_ID = "google_mail";

function OAuthReturn() {
  const [message, setMessage] = useState("Finishing connection…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const notifyOpenerAndClose = (
      type: "appUserConnectorOAuthComplete" | "appUserConnectorOAuthFailed",
    ) => {
      window.opener?.postMessage({ type, connectorId: CONNECTOR_ID }, window.location.origin);
      window.close();
    };

    if (params.get("success") !== "true") {
      setMessage(params.get("error") ?? "Authorization did not complete.");
      notifyOpenerAndClose("appUserConnectorOAuthFailed");
      return;
    }
    const code = params.get("code");
    if (!code) {
      if (params.get("offline_access_allowed") === "false") {
        notifyOpenerAndClose("appUserConnectorOAuthComplete");
        return;
      }
      setMessage("Authorization completed without an exchange code.");
      notifyOpenerAndClose("appUserConnectorOAuthFailed");
      return;
    }
    void completeGmailConnect({ data: { code } })
      .then(() => notifyOpenerAndClose("appUserConnectorOAuthComplete"))
      .catch(() => {
        setMessage("Could not finish the connection.");
        notifyOpenerAndClose("appUserConnectorOAuthFailed");
      });
  }, []);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4">
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
